import React from "react";
import { Checkbox, Spin, Tooltip } from "antd";
import { formatProductTitle, formatLocationTitle, SPEC_TYPE } from "../utils/utils";
import addFillIcon from "../../../../assets/images/product/specmanager/add-fill.svg";
import "./AllProductsList.css";

export default function AllProductsList({
  products,
  identifierFields,
  loading,
  selectedProductIds,
  onToggleChecked,
  specType = SPEC_TYPE.PRODUCT,
}) {
  const isEnvironmentSpec = specType === SPEC_TYPE.ENVIRONMENT;

  const formatItemTitle = (productRow) => {
    if (isEnvironmentSpec) {
      return formatLocationTitle(productRow, identifierFields);
    }
    return formatProductTitle(productRow, identifierFields);
  };

  if (loading) {
    return (
      <div className="AllProductsList_Loading">
        <Spin />
      </div>
    );
  }

  if (!products.length) {
    const emptyLabel = isEnvironmentSpec ? "No locations found" : "No products found";
    return (
      <div className="AllProductsList_Empty">
        {emptyLabel}
      </div>
    );
  }

  return (
    <ul className="AllProductsList_List">
      {products.map((productRow) => {
        const productId = String(productRow.product_id);
        const isSelected = selectedProductIds.has(productId);
        const title = formatItemTitle(productRow);
        const itemClassName = [
          "AllProductsList_Item",
          isSelected && "AllProductsList_Item--selected",
        ].filter(Boolean).join(" ");

        return (
          <li
            key={productRow.product_id}
            className={itemClassName}
            onClick={() => {
              if (isSelected) return;
              onToggleChecked(productRow, true);
            }}
          >
            <div
              className="AllProductsList_CheckboxWrap"
              onClick={(event) => event.stopPropagation()}
              role="presentation"
            >
              <Checkbox
                checked={isSelected}
                onChange={(event) => {
                  if (event.target.checked && !isSelected) {
                    onToggleChecked(productRow, true);
                  }
                }}
              />
            </div>
            <span className="AllProductsList_Text">{title}</span>
            {!isSelected && (
              <Tooltip title={title} placement="left">
                <button
                  type="button"
                  className="AllProductsList_AddButton"
                  aria-label={`Add ${title}`}
                  onClick={(event) => {
                    event.stopPropagation();
                    onToggleChecked(productRow, true);
                  }}
                >
                  <img src={addFillIcon} alt="" width={16} height={16} />
                </button>
              </Tooltip>
            )}
          </li>
        );
      })}
    </ul>
  );
}
